import { render, staticRenderFns } from "./List.vue?vue&type=template&id=35a354ee&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=35a354ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a354ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a354ee')) {
      api.createRecord('35a354ee', component.options)
    } else {
      api.reload('35a354ee', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=35a354ee&scoped=true&", function () {
      api.rerender('35a354ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/List.vue"
export default component.exports